import MENDES_EXT_1 from "./MENDES_EXT_1";
export default {
  MENDES_EXT_1,
};
